import DataImportFormTabs from '../../../components/3modules/DataImportFormTabs'
import PeopleImportTemplate from '../../../components/5templates/PeopleImportTemplate'
import { useNavigate } from 'react-router-dom'
import {useState} from 'react'
import {
    getItemFromSessionStorage, removeAllItemsInSessionStorage, setItemToSessionStorage
} from '../../../services/util/sessionStorageManager'
import {
    contactListFormatter, areAllObjectValuesEmpty
} from '../../../services/util/miscellaneousService'
import ApiService from '../../../common/ApiCalls'
import {FeedbackSnackbar} from '../../../components/1elements'
import LoaderBackdrop from '../../../components/2compounds/LoaderBackdrop'

const ImportPeopleForm = () => {
    const navigate = useNavigate()
    const [selectedContactList, setSelectedContactList] = useState({})
    const [snackbar, setSnackbar] = useState(
        {isOpen: false, severity: "", message: "Information is successfully saved!"})
    const [formCheckSnackbar, setFormCheckSnackbar] = useState(false)
    const [organizationName, setOrganizationName] = useState('')
    const [organizationId, setOrganizationId] = useState('')
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [approver, setApprover] = useState(null)
    const [showError, setShowError] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [loaded, setLoaded] = useState(false)

    const onSave = () => {
        if(approver){
            setIsModalOpen(false)
            setIsLoading(true)
            const selectedClient = getItemFromSessionStorage('selectedClient')
            const selectedLocation = getItemFromSessionStorage('selectedLocation')
            const {existingContacts, newContacts} =
                contactListFormatter(getItemFromSessionStorage('newContact'))
            const initiatorId = localStorage.getItem('userId')
            const initiatorEmail = localStorage.getItem('email')
            const pendingDataId = getItemFromSessionStorage('pendingDataId')
            const importType = getItemFromSessionStorage('importType')

            const contact = {
                pendingDataId: pendingDataId ? pendingDataId : '',
                initiatorId,
                initiatorEmail,
                approverId: approver['user_id'],
                accountId: selectedClient.account_id,
                id: selectedLocation.location_id,
                newContacts,
                existingContacts: existingContacts,
                importType
            }

            ApiService().addNewContactsToExistingLocation(contact)
                .then(()=>{
                    const data = {email: approver.email, name: approver.username}
                    ApiService().notifyApprover(data)
                        .catch((err)=>{
                            console.log(err)
                        })
                })
                .then(()=>{
                    setLoaded(true)
                    setSnackbar(prevState => {return {...prevState, severity: 'success', isOpen: true}})
                    window.setTimeout(()=>{
                        onCancel()
                    }, 2000)
                })
                .catch((err)=>{
                    setSnackbar(prevState => {return {...prevState, severity: 'fail', isOpen: true}})
                    console.log(err)
                })
        }else{
            setShowError(true)
        }
    }
    const onCancel = () => {
        removeAllItemsInSessionStorage()
        navigate('/adminDashboard')
    }
    const onPrev = () => {
        setItemToSessionStorage('newContact', selectedContactList)
        navigate('/adminDashboard')
    }
    const onNext = () => {
        setItemToSessionStorage('newContact', selectedContactList)
        if(!areAllObjectValuesEmpty(selectedContactList)){
            setIsModalOpen(true)
        }else{
            setFormCheckSnackbar(true)
        }
    }

    return(
        <DataImportFormTabs flow={'addPeople'}>
            <PeopleImportTemplate selectedContactList={selectedContactList} setSelectedContactList={setSelectedContactList}
                                  onPrev={onPrev} onNext={onNext} onSave={onSave} organizationName={organizationName}
                                  setOrganizationName={setOrganizationName} organizationId={organizationId}
                                  setOrganizationId={setOrganizationId} isModalOpen={isModalOpen}
                                  setIsModalOpen={setIsModalOpen} approver={approver} setApprover={setApprover}
                                  formCheckSnackbar={formCheckSnackbar} setFormCheckSnackbar={setFormCheckSnackbar}
                                  showErrorApprover={showError}/>
            <FeedbackSnackbar setSnackbar={setSnackbar} snackbar={snackbar} />
            <LoaderBackdrop open={isLoading} loaded={loaded} />
        </DataImportFormTabs>
    )
}

export default ImportPeopleForm
